export default __webpack_public_path__ + "images/MQ.ca0a4d6.png";